import i18n from '@/i18n/config';

/** Display label for API role slugs (e.g. super_admin). */
export function roleLabel(roleName: string | undefined | null): string {
  if (!roleName) return i18n.t('common.unknown');

  switch (roleName) {
    case 'super_admin':
      return i18n.t('enums.superAdmin');
    case 'admin':
      return i18n.t('enums.admin');
    case 'customer':
      return i18n.t('enums.customer');
    default:
      return roleName.replace(/_/g, ' ');
  }
}
